import { Component } from '@angular/core';

@Component({
  selector: 'app-print-layout',
  templateUrl: './print-layout.component.html',
  styleUrl: './print-layout.component.less',
  standalone: false,
})
export class PrintLayoutComponent {}
